import React from 'react';
import { useTranslation } from 'react-i18next';
import { AdminPage, PageHeader } from 'components';
import { VisitorWatchlistForm } from 'domains/visitorManagement/components/VisitorWatchlistForm/VisitorWatchlistForm';
import { useIsAdminView, useChannelAdminContext } from 'hooks';
import { routes } from 'lane-shared/config';
import { useUserDataContext } from 'lane-shared/hooks';
import { hasPermission } from 'lane-shared/helpers';
import { PERMISSION_KEYS } from 'constants-permissions';
import { Alert, AlertType } from 'components/lds';
import { Channel } from 'lane-shared/types/ChannelType';
import { UserType } from 'lane-shared/types/User';

const TRANSLATION_KEYS = {
  title: 'web.admin.channel.visitor.watchlist.pageTitle',
  description: 'web.admin.channel.visitor.watchlist.description',
  breadcrumb: 'web.admin.channel.visitor.watchlist.breadcrumb.add',
  watchlist: 'web.admin.channel.visitor.watchlist.breadcrumb',
};

export function VisitorWatchlistFormPage({
  channel: channelProp,
  user: userProp,
}: {
  channel?: Channel | any;
  user?: UserType;
}) {
  const { t } = useTranslation();
  const [, channelSlug] = useIsAdminView();
  const { user: userFromContext } = useUserDataContext();
  const { channel: channelFromContext } = useChannelAdminContext();
  
  const user = userProp || userFromContext;
  const channel = channelProp || channelFromContext;

  // Check if user has manage permission for watchlist
  const hasManageWatchlistPermission =
    user?.isSuperUser ||
    (channel?._id &&
      hasPermission(
        user?.roles,
        [PERMISSION_KEYS.PERMISSION_VISITORS_WATCHLIST_MANAGE],
        channel._id
      ));

  if (!hasManageWatchlistPermission) {
    return (
      <AdminPage>
        <Alert type={AlertType.error} fullWidth>
          {t('web.admin.channel.visitor.watchlist.permission.manage.required')}
        </Alert>
      </AdminPage>
    );
  }

  return (
    <AdminPage>
      <PageHeader
        header={t(TRANSLATION_KEYS.title)}
        description={t(TRANSLATION_KEYS.description)}
        breadcrumbs={[
          { 
            label: t(TRANSLATION_KEYS.watchlist), 
            url: channelSlug ? routes.visitorManagementWatchlist.replace(':id', channelSlug) : '#'
          },
          { label: t(TRANSLATION_KEYS.breadcrumb) },
        ]}
      />
      <VisitorWatchlistForm />
    </AdminPage>
  );
}